export const SALES_LEAGUE_ROWS_PER_PAGE = 25;

export const SALES_LEAGUE_ROWS_PER_PAGE_OPTIONS = [10, 25, 50];
